const normaliseMake = (make) =>
  make
    .replace('VW', 'Volkswagen')
    .replace('Š', 'S')
    .replace(/\W+/g, '') // Sanitise white-space or odd characters
    .toLowerCase()

export default normaliseMake
